<body>

    <div class="flex-container">

        <div class="mobi">
            <div mat-dialog-title class="flex-row" style="display: flex;
                    justify-content: space-between;">
                <div class="text-left">Dados de pagamento</div>
                <div class="text-right">Total R$ {{valorTotal}}</div>
            </div>
            <h5> Selecione uma forma de pagamento</h5>
            <div mat-dialog-title class="flex-row" style="display: flex; justify-content:center;">

                <div class="btnPgto" *ngIf="tipoCartao" [ngStyle]="{'border-color': tipoPagamento === 1 ? '#0088ff' : '#c0c0c0',
                                                       'border-width': tipoPagamento === 1 ? '3px' : '2px'}"
                    (click)="lerCodigo(1)">
                    <img src="assets/creditcard.png" alt="Cartão">
                </div>
                <div class="btnPgto" *ngIf="tipoPix" [ngStyle]="{'border-color': tipoPagamento === 8 ? '#0088ff' : '#c0c0c0',
                                                       'border-width': tipoPagamento === 8 ? '3px' : '2px'}"
                    (click)="lerCodigo(8)">
                    <img src="assets/pix.png" alt="PIX">
                </div>
                <div class="btnPgto" *ngIf="tipoBoleto" [ngStyle]="{'border-color': tipoPagamento === 3 ? '#0088ff' : '#c0c0c0',
                                                       'border-width': tipoPagamento === 3 ? '3px' : '2px'}"
                    (click)="lerCodigo(3)">
                    <img src="assets/barcode.png" alt="Boleto">
                </div>

            </div>

            <hr class="divider">

            <div *ngIf="codigoLinha" class="form-group" [ngClass]="{'mobile-view': isMobileScreen}">
                <div mat-dialog-title class="flex-row" style="display: flex;
                        justify-content: space-between;">
                    <div class="text-left">Pagamento via {{tipoPgto}}</div>
                </div>
                <ng-container *ngFor="let item of codigoPagamento; let i = index">
                    <div class="input-container">
                        <mat-form-field class="custom-form-field codText">
                            <input matInput style="width: 100%;" [value]="item" readonly>
                        </mat-form-field>
                        <div style="width: 50px; position: relative; top: -10px">
                            <button mat-icon-button (click)="copyToClipboard(item)">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                            <span style="top: -7px; position: relative;">Copiar</span>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div *ngIf="objCartao">
                <div mat-dialog-title class="flex-row" style="display: flex;
        justify-content: space-between;">
                    <div class="text-left">Pagamento via cartão crédito</div>
                </div>
                <div mat-dialog-content>
                    <form [formGroup]="form" *ngIf="form">
                        <ng-container formArrayName="cartoes">
                            <ng-container *ngFor="let cartao of cartoes.controls; let i=index">
                                <div [formGroupName]="i" class="flex flex-row"
                                    [ngClass]="((i !== 0) && (i % 2) !== 0) ? 'bg-grey' : ''">

                                    <app-draw-credit #drawCreditCard [cardData]="getCardData(i)"></app-draw-credit>

                                    <div class="form-cartao prl-1-5 flex-fill mt-1">
                                        <div class="grid grid--auto-fill w-100">
                                            <mat-form-field class="valorText">
                                                <mat-label>VALOR &nbsp; &nbsp;</mat-label>
                                                <span matPrefix><strong>R$</strong> &nbsp;</span>
                                                <input style="text-align: right; color:black !important" matInput
                                                    formControlName="valor" (focus)="drawCreditCard.unflip()">
                                                <mat-error *ngIf="hasError(i, 'bigValue')">Valor acima do
                                                    total</mat-error>
                                                <mat-error *ngIf="hasError(i, 'required')">Informação
                                                    necessária</mat-error>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>Parcelas</mat-label>
                                                <mat-select formControlName="parcela">
                                                    <mat-option *ngFor="let parcela of opcoesParcelamento"
                                                        [value]="parcela">{{
                                                        parcela
                                                        }} parcela{{ parcela == 1 ? '' : 's' }}</mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>NÚMERO DO CARTÃO</mat-label>
                                                <input matInput formControlName="numero" mask="0000 0000 0000 0000"
                                                    (focus)="drawCreditCard.unflip()">
                                                <mat-error>Informação necessária</mat-error>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>NOME QUE APARECE NO CARTÃO</mat-label>
                                                <input #nome matInput formControlName="nome" maxlength="50"
                                                    (focus)="drawCreditCard.unflip()" appTitlecase>
                                                <mat-hint align="end">{{nome.value?.length || 0}}/50</mat-hint>
                                                <mat-error>Informação necessária</mat-error>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>Mês</mat-label>
                                                <mat-select formControlName="mes" (selectionChange)="drawCreditCard.unflip()">
                                                    <mat-option *ngFor="let m of meses" [value]="m.value">{{ m.label }}</mat-option>
                                                </mat-select>
                                                <mat-error>Informação necessária</mat-error>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>Ano</mat-label>
                                                <mat-select formControlName="ano" (selectionChange)="drawCreditCard.unflip()">
                                                    <mat-option *ngFor="let a of anosValidade" [value]="a">{{ a }}</mat-option>
                                                </mat-select>
                                                <mat-error>Informação necessária</mat-error>
                                            </mat-form-field>

                                            <mat-form-field>
                                                <mat-label>CÓDIGO DE SEGURANÇA</mat-label>
                                                <input matInput formControlName="codigo" mask="000"
                                                    (focus)="drawCreditCard.flip()">
                                                <mat-error>Informação necessária</mat-error>
                                            </mat-form-field>
                                            <!-- RF-09: CPF do titular do cartão -->
                                            <div style="width: 100%; margin-top: 8px;">
                                                <mat-checkbox formControlName="informarCpfTitular">
                                                    Informar CPF do titular do cartão
                                                </mat-checkbox>
                                                <mat-form-field *ngIf="cartao.get('informarCpfTitular').value" style="width: 100%; margin-top: 4px;">
                                                    <mat-label>CPF do titular</mat-label>
                                                    <input matInput formControlName="cpfTitular" mask="000.000.000-00" placeholder="000.000.000-00">
                                                </mat-form-field>
                                            </div>
                                            <div class="btn-options prl-1-5">
                                                <button *ngIf="i !== 0" mat-icon-button type="button"
                                                    (click)="removeDoFormArray(form.get('cartoes'), i)" color="warn"
                                                    matTooltip="Excluir cartão">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <div mat-dialog-actions>
                                            <!-- <button mat-raised-button type="button" (click)="addCartoes()" color="accent">Adicionar outo cartão</button> -->
                                            <button mat-raised-button type="button"
                                                (click)="efetuarPagamentoCartaoCredito()" color="primary">Efetuar
                                                pagamento</button>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </form>
                    <mat-progress-bar *ngIf="efetuandoPagamento" mode="indeterminate"
                        color="primary"></mat-progress-bar>
                </div>
            </div>

        </div>
    </div>
</body>